import { Flex } from '@chakra-ui/react';
import { MultipleChoiceFilter } from '@duke-hq/ui/components/MultipleChoice/MultipleChoiceFilter';
import { useTenantContext } from '../TenantContext';
import { SortOrder } from '@duke-hq/lib/pagination';

interface Filters {
  orderBy?: string | undefined;
  sort?: SortOrder | undefined;
  consultantIds?: string | undefined;
}

interface FilterOption {
  id: string;
  value: string;
  label: string;
  element?: React.ReactElement;
}

interface ParticipantFiltersProps {
  filters: Filters;
  consultantOptions: FilterOption[];
  onChange: (newFilters: Filters) => void;
}

export function ParticipantFilters({
  filters,
  consultantOptions,
  onChange,
}: ParticipantFiltersProps) {
  const tenantCtx = useTenantContext();
  const userCanCreateReferralsForTeamMembers = tenantCtx?.permissions.includes(
    'canCreateReferralsForTeamMembers',
  );

  return (
    <Flex gap={2}>
      {userCanCreateReferralsForTeamMembers === true ? (
        <MultipleChoiceFilter
          items={consultantOptions}
          label="Consultant"
          name="consultantIds"
          value={filters.consultantIds}
          onFilterChange={onChange}
        />
      ) : null}
    </Flex>
  );
}
